module.exports = __webpack_public_path__ + "img/recruit-bg.3039ff42.png";